import styledWithTheme, { css } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const SKELETON_TITLE_WIDTH = 170;
const SKELETON_TITLE_HEIGHT = 16;
const SKELETON_TITLE_MARGIN_TOP = 12;
const SKELETON_DESCRIPTION_WIDTH = 520;
const SKELETON_DESCRIPTION_HEIGHT = 40;
const SKELETON_DESCRIPTION_MARGIN_TOP = 9;
const SKELETON_DESCRIPTION_MARGIN_BOTTOM = 16;
const SkeletonBase = styledWithTheme.div(({
  theme
}) => css(["@keyframes pulse{0%{background-color:", ";}50%{background-color:", ";}100%{background-color:", ";}}display:inline-block;height:", "px;width:", "px;border-radius:3px;margin-top:", "px;margin-bottom:", "px;animation:pulse 2s ease-in-out infinite;"], theme.color['fill-surface-raised'], theme.color['fill-primary-disabled'], theme.color['fill-surface-raised'], props => props.type === 'description' ? SKELETON_DESCRIPTION_HEIGHT : SKELETON_TITLE_HEIGHT, props => props.type === 'description' ? SKELETON_DESCRIPTION_WIDTH : SKELETON_TITLE_WIDTH, props => props.type === 'description' ? SKELETON_DESCRIPTION_MARGIN_TOP : SKELETON_TITLE_MARGIN_TOP, props => props.type === 'description' ? SKELETON_DESCRIPTION_MARGIN_BOTTOM : 0));

// Values here are not tokenized/themable so we want the fine-grained control
// @bend-expect trellis-tokenized
const Skeleton = props => /*#__PURE__*/_jsx(SkeletonBase, Object.assign({}, props));
export default Skeleton;